import { ThemeName, THEMES } from "../theme";

import legacyLogo from "../assets/sjLogos/security-journey-logo.svg";
import atlasLightLogo from "../assets/sjLogos/sj-logo-atlas-light.svg";
import atlasDarkLogo from "../assets/sjLogos/sj-logo-atlas-dark.svg";

export const isAtlasTheme = (themeName: ThemeName): boolean => {
  return themeName !== "sj-legacy";
};

export const getThemeLogo = (themeName: ThemeName | null) => {
  switch (themeName) {
    case THEMES["atlas-dark"].name:
      return atlasDarkLogo;
    case THEMES["atlas-light"].name:
      return atlasLightLogo;
    default:
      return legacyLogo;
  }
};

/**
 * Checks if the current theme in localStorage is an Atlas theme
 * @returns {boolean} True if current theme is 'atlas-light' or 'atlas-dark'
 */
export const useAtlasTheme = () => {
  const currentTheme = localStorage.getItem("sj-theme");
  return currentTheme ? isAtlasTheme(currentTheme as ThemeName) : false;
};
